import { render, staticRenderFns } from "./InventoryFavourites.vue?vue&type=template&id=d20441f4&"
import script from "./InventoryFavourites.vue?vue&type=script&lang=js&"
export * from "./InventoryFavourites.vue?vue&type=script&lang=js&"
import style0 from "./InventoryFavourites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports